webpackJsonp([14],{

/***/ 286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_index__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__layout_index__);




var NovelChapter = function NovelChapter(resolve) {
  return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(713)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var EditNovel = function EditNovel(resolve) {
  return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(710)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var NewNovel = function NewNovel(resolve) {
  return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(712)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var NovelList = function NovelList(resolve) {
  return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(715)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var NovelInfoEdit = function NovelInfoEdit(resolve) {
  return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(714)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var NewChapterData = function NewChapterData(resolve) {
  return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(716)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var NewChapterList = function NewChapterList(resolve) {
  return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(711)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var Comments = function Comments(resolve) {
  return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(708)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var Roles = function Roles(resolve) {
  return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(717)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Users = function Users(resolve) {
  return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(718)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var BookInformationList = function BookInformationList(resolve) {
  return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(707)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [
  // {
  //   path: '*',
  //   redirect: '/home'
  // },
  {
    path: '/login',
    component: function component() {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 706));
    }
  }, {
    path: '/',
    redirect: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__layout_index___default.a,
    children: [{
      path: 'home',
      name: 'home',
      meta: {
        icon: 'home',
        title: 'Home'
      },
      component: function component() {
        return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 709));
      }
    }]
  }, {
    name: 'Novel',
    path: '/novel',
    meta: { authorize: 1001 },
    component: __WEBPACK_IMPORTED_MODULE_2__layout_index___default.a,
    children: [{
      path: 'chapter/:id',
      meta: { authorize: 2002 },
      component: NovelChapter
    }, {
      path: 'edit/:id',
      meta: { authorize: 2002 },
      component: EditNovel
    }, {
      path: 'new',
      meta: { authorize: 2002 },
      component: NewNovel
    }, {
      name: 'Novel List',
      path: 'list',
      meta: { authorize: 2002 },
      component: NovelList
    }, {
      name: 'New Chapter Data',
      path: 'chapterData',
      meta: { authorize: 20021 },
      component: NewChapterData
    }, {
      path: 'info/edit/:id',
      meta: { authorize: 2002 },
      component: NovelInfoEdit
    }, {
      name: 'New Chapters List',
      path: 'newchapterlist',
      meta: { authorize: 2031 },
      component: NewChapterList
    }]
  }, {
    name: 'App Management',
    path: '/app-management',
    meta: { authorize: 1005 },
    component: __WEBPACK_IMPORTED_MODULE_2__layout_index___default.a,
    children: [{
      name: 'Comments Management',
      path: 'comments',
      meta: { authorize: 2023 },
      component: Comments
    }]
  }, {
    name: 'Book Information',
    path: '/bookinformation',
    meta: { authorize: 1010 },
    component: __WEBPACK_IMPORTED_MODULE_2__layout_index___default.a,
    children: [{
      name: 'List',
      path: 'list',
      meta: { authorize: 2032 },
      component: BookInformationList
    }]
  }, {
    name: 'Settings',
    path: '/settings',
    meta: { authorize: 1008 },
    component: __WEBPACK_IMPORTED_MODULE_2__layout_index___default.a,
    children: [{
      name: 'Manage Admin Users',
      path: 'users',
      meta: { authorize: 2014 },
      component: Users
    }, {
      name: 'Manage Roles',
      path: 'roles',
      meta: { authorize: 2015 },
      component: Roles
    }]
  }]
});

router.beforeEach(function (to, from, next) {
  var token = window.localStorage.getItem('user-token');
  var permissions = window.localStorage.getItem('user-permissions');
  if (to.path === '/login') {
    // 如果是跳转到登录页的
    next(); // 否则跳转回登录页
  } else {
    if (token) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + token; // 注意Bearer后有个空格
      // redirect to login page if not logged in and trying to access a restricted page
      var authorize = to.meta.authorize;


      if (authorize) {
        // check if route is restricted by role
        if (permissions.includes(authorize)) {
          // role not authorised so redirect to home page
          next();
        } else {
          next('/');
        }
      } else {
        next();
      }
    } else {
      next('/login'); // 否则跳转回登录页
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 289:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 290:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(655)
}
var Component = __webpack_require__(108)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(666),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 354:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_normalize_css__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_en__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_default_index_css__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_clipboard2__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_v_charts__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_v_charts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_v_charts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_json_csv__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_json_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_json_csv__);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.












__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('downloadCsv', __WEBPACK_IMPORTED_MODULE_11_vue_json_csv___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_v_charts___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui___default.a, {
  locale: __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_en___default.a
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_clipboard2___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
var http = __WEBPACK_IMPORTED_MODULE_4_axios___default.a.create({
  baseURL: ''
});

http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  console.log('the error.response.status is ----', error.response.status);
  if (error.response.status === 401) {
    window.localStorage.setItem('user-token', ''); // 将token清空
    window.localStorage.setItem('user-name', '');
    window.localStorage.setItem('user-id', '');
    window.localStorage.setItem('token-expire', 'true');
    window.history.go(0);
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$http = http;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_2__App___default.a
  }
});

/***/ }),

/***/ 355:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      login: true
    };
  }
});

/***/ }),

/***/ 356:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'headerNavigation',
  data: function data() {
    return {
      name: '',
      walletManager: ['admin'],
      routeList: null,
      permissions: window.localStorage.getItem('user-permissions')
    };
  },

  methods: {
    logout: function logout() {
      console.log('system logout');
      localStorage.setItem('user-token', ''); // 将token清空
      localStorage.setItem('user-name', '');
      localStorage.setItem('user-id', '');
      window.localStorage.setItem('token-expire', 'false');
      window.history.go(0); // 退出登录时，刷新页面。两个作用：1，解决过多组件回收卡顿（销毁vs回收）；2. 使 keep-alive 页面登录后重新加载数据(mount 钩子生效)
    },
    createNavigation: function createNavigation() {
      this.routeList = this.$router.options.routes.filter(function (route) {
        if (route.name) return route;
      });
    },
    childrenMenu: function childrenMenu(_childrenMenu) {
      return _childrenMenu.filter(function (route) {
        if (route.name) return route;
      });
    }
  },
  mounted: function mounted() {
    this.createNavigation();
    this.name = localStorage.getItem('user-name');
  }
});

/***/ }),

/***/ 357:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Header__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { NovelHeader: __WEBPACK_IMPORTED_MODULE_0__components_Header___default.a }
});

/***/ }),

/***/ 654:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 655:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 656:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(654)
}
var Component = __webpack_require__(108)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(665),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3800c1b6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 664:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(656)
}
var Component = __webpack_require__(108)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(667),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 665:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "theme": "light",
      "router": true,
      "mode": "horizontal"
    }
  }, [_c('li', {
    staticClass: "el-submenu",
    staticStyle: {
      "width": "80px",
      "height": "60px"
    }
  }), _vm._v(" "), _vm._l((_vm.routeList), function(item, index) {
    return (_vm.permissions.includes(item.meta.authorize)) ? _c('el-submenu', {
      key: index,
      attrs: {
        "index": ("" + (index+1))
      }
    }, [_c('template', {
      slot: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((_vm.childrenMenu(item.children)), function(children, i) {
      return (_vm.permissions.includes(children.meta.authorize)) ? _c('el-menu-item', {
        key: i,
        attrs: {
          "index": ((item.path) + "/" + (children.path))
        }
      }, [_vm._v("\n        " + _vm._s(children.name) + "\n      ")]) : _vm._e()
    })], 2) : _vm._e()
  }), _vm._v(" "), _c('el-submenu', {
    staticClass: "user",
    attrs: {
      "index": "0"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "logout",
    attrs: {
      "index": "0-1"
    },
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("logout")])], 2)], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 666:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 667:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('NovelHeader'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ })

},[354]);


// WEBPACK FOOTER //
// static/js/app.67d462ce567e1c0ffdb1.js